import React from "react";
import Navbar from "./global-components/navbar";
import { useParams } from "react-router-dom";
import PageHeader from "./global-components/page-header";
import EBikeBatterySlider from "./shop-components/e-bike-slider";
import EBikeBatteryDetails from "./shop-components/e-bike-battery-details";
// import CallToActionV1 from "./section-components/call-to-action-v1";
import Footer from "./global-components/footer";
import eBikesData from "../data/eBikesData";

const E_Bikes_Battery = () => {
  const { id } = useParams(); // ✅ Get the ID from the URL
  const ebike = eBikesData.find((item) => item.id === id); // ✅ Find the matching inverter
  console.log(ebike, "e-BIKE DATA");

  if (!ebike) {
    return (
      <div className="container text-center mt-5">
        <h2>Product Not Found</h2>
        <p>The requested e-bike data does not exist.</p>
      </div>
    );
  }

  return (
    <div>
      <Navbar />
      <PageHeader headertitle={ebike.name} customclass="mb-0" Img="24.jpg" />
      <EBikeBatterySlider />
      <EBikeBatteryDetails ebike={ebike} />
      {/* <CallToActionV1 /> */}
      <Footer />
    </div>
  );
};

export default E_Bikes_Battery;
